import { createSlice } from "@reduxjs/toolkit";

const ManagePasswordSlice = createSlice({
    name: "managePassword",
    initialState: {show: false,  isForNewUser: false},
    reducers: {
        openModal: (state, action) => {
            state.show = true;
            state.isForNewUser = action.payload?.isForNewUser || false;
        },
        closeModal: (state) => {
            state.show = false;
            state.isForNewUser = false;
        }
    }
});

export const {openModal,closeModal} = ManagePasswordSlice.actions;
export default ManagePasswordSlice.reducer;